export default __webpack_public_path__ + "static/media/kn.e76f2855.svg";